<template>
<div>
  <div class="feature">
    <router-link tag="div" class="image" :style="`background-image: url('${$options.filters.imgix(currentArtist.feature_image)}')`" :to="`artist/${currentArtist.slug}`" v-if="currentArtist"></router-link>
  </div>

  <div class="gallery__container" v-if="homeGallery">
    <artist-gallery class="gallery" position="home" :gallery="homeGallery" v-observe-visibility="visibilityChanged" :playVideo="playVideo"></artist-gallery>
  </div>

  <div class="message">
    <div class="size-large" v-html="$options.filters.markdown(excerpt)"></div>

    <div class="button size-large">
      <router-link to="/about">Read more <icon-arrow></icon-arrow></router-link>
    </div>
  </div>

  <div class="navigation">
    <div class="row" v-if="upcomingArtist">
      <div class="col image" :style="`background-image: url('${$options.filters.imgix(upcomingArtist.profile_image, { h: 480 })}')`"></div>

      <div class="col col--text">
        <div class="text size-medium">
          Upcoming Artist:<br />
          {{upcomingArtist.title}}
        </div>

        <div class="button-outer">
          <router-link class="button size-small" :to="`/artist/${upcomingArtist.slug}`">See profile</router-link>
        </div>
      </div>
    </div>

    <div class="row" v-if="previousArtist">
      <div class="col image" :style="`background-image: url('${$options.filters.imgix(previousArtist.profile_image, { h: 480 })}')`"></div>

      <div class="col col--text">
        <div class="text size-medium">
          Previous Artist:<br />
          {{previousArtist.title}}
        </div>

        <div class="button-outer">
          <router-link class="button size-small" :to="`/artist/${previousArtist.slug}`">See profile</router-link>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import iconArrow from '!vue-svg-loader!../../static/images/arrow.svg'

export default Vue.component('RouteHome', {
  data: () => ({
    playVideo: false
  }),
  components: {
    iconArrow
  },
  methods: {
    openArtistOverlay(slug) {
      this.$store.commit('openArtistOverlay', slug)
    },
    visibilityChanged(visible, entry) {
      if(visible) this.playVideo = true
    }
  },
  computed: {
    ...mapGetters('artists', ['currentArtist', 'previousArtist', 'upcomingArtist']),
    ...mapGetters('site', ['excerpt', 'homeGallery'])
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.feature {
  height: 100vh;
  cursor: pointer;
  position: relative;
  .image {
    width: 100vw;
    height: 100vh;
    background-size: initial;
    background-repeat: repeat;
  }
}

.message {
  min-height: 100vh;
  background: $color-red;
  line-height: 1;
  text-transform: uppercase;
  padding: 3.4rem;
  display: flex;
  flex-direction: column;

  @media (max-width: $break-small) {
    padding: $gutter;
    font-size: $size-medium;
    line-height: 1.1;
  }

  .button {
    color: $color-white;
    margin-top: auto;
    .arrow {
      height: 0.8em;
      width: auto;
      transform: rotate(-90deg);
      position: relative;
      top: 0.1rem;
      margin-left: 0.2em;
      /deep/ path {
        stroke: currentColor;
      }
    }
    a {
      &:hover {
        color: $color-black;
      }
    }
  }
}

.navigation {
  background: $color-white;
  color: $color-blue;
  text-transform: uppercase;
  .row {
    display: flex;
    flex-wrap: wrap;
    @media (min-width: $break-medium) {
      &:nth-child(2) {
        flex-direction: row-reverse;
      }
    }
    .col {
      height: 50vh;
      flex: 1;
      padding: $gutter;
      display: flex;
      flex-direction: column;
      @media (max-width: $break-medium) {
        width: 100%;
        flex: none;
        height: 32rem;
        &--text {
          margin-bottom: auto;
        }
      }
    }
    .text {
      line-height: 1;
      margin-bottom: 1em;
    }
    .button-outer {
      margin-top: auto;
      margin-right: auto;
    }
    .button {
      border: 2px solid $color-blue;
      padding: 0.9rem 1.2rem 0.8rem;
      font-family: $font-mono;
      font-weight: normal;
      background: $color-blue;
      color: $color-white;
      &:hover {
        background: $color-white;
        color: $color-blue;
      }
    }
  }
  .image {
    background-color: $color-gray;
    color: $color-white;
    background-position: center;
    background-size: cover;
  }
}

.gallery {
  &__container {
    padding: 10rem 0;
    background: $color-white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (min-width: #{$break-small+1px}) {
      min-height: 100vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/routes/route-home.vue